function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
    
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
    
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function fireEvent(element,event){
    if (document.createEventObject){
    // dispatch for IE
    var evt = document.createEventObject();
    return element.fireEvent('on'+event,evt)
    }
    else{
    // dispatch for firefox + others
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent(event, true, true ); // event type,bubbling,cancelable
    return !element.dispatchEvent(evt);
    }
}

function formatProductMoney(price) {
  return (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(price / 100));
}

function getProductVariantPackCount(variant) {
  if (!variant) {
    return 0;
  }

  const valuesToCheck = [];
  if (variant.options && variant.options.length) {
    valuesToCheck.push(...variant.options);
  }
  if (variant.title) {
    valuesToCheck.push(variant.title);
  }

  for (const value of valuesToCheck) {
    if (!value) continue;

    const packMatch = String(value).match(/(\d+)\s*pack/i);
    if (packMatch) {
      return Number(packMatch[1]);
    }

    const plainNumberMatch = String(value).match(/^(\d+)$/);
    if (plainNumberMatch) {
      return Number(plainNumberMatch[1]);
    }
  }

  return 0;
}

function getSelectedProductVariant() {
  const productTemplate = document.querySelector('[data-product-template]');
  if (!productTemplate || productTemplate.querySelector('[data-product-json]') == null) {
    return null;
  }

  const productJson = JSON.parse(productTemplate.querySelector('[data-product-json]').textContent);
  const fieldsets = Array.from(productTemplate.querySelectorAll('fieldset'));
  const selectedValue = fieldsets.map((fieldset) => {
    const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
    return checkedRadio ? checkedRadio.value : null;
  });

  return productJson.variants.find((variant) => JSON.stringify(variant.options) == JSON.stringify(selectedValue)) || null;
}

function getProductSectionRequestUrl(variantId) {
  const productTemplate = document.querySelector('[data-product-template]');
  const variantSwitcher = productTemplate?.querySelector('variant-radios, variant-selects');
  const sectionId = productTemplate?.dataset.section;
  const productUrl = variantSwitcher?.dataset.url || window.location.pathname;

  if (!sectionId || !variantId) {
    return null;
  }

  return `${productUrl}?variant=${variantId}&section_id=${sectionId}`;
}

function updateVariantInUrl(variantId) {
  if (!variantId) {
    return;
  }

  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get('variant') === String(variantId)) {
    return;
  }

  currentUrl.searchParams.set('variant', String(variantId));
  window.history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
}

function replaceRechargeWidgetMarkup(markup) {
  if (!markup) {
    return false;
  }

  const parsedHtml = new DOMParser().parseFromString(markup, 'text/html');
  const nextWidget = parsedHtml.querySelector('recharge-subscription-widget');
  const currentWidget = document.querySelector('[data-product-template] recharge-subscription-widget');

  if (!nextWidget || !currentWidget || !currentWidget.parentNode) {
    return false;
  }
  nextWidget.setAttribute('hidden', '');  
  currentWidget.parentNode.replaceChild(nextWidget, currentWidget);
  return true;
}

function fetchRechargeWidgetForSelectedVariant() {
  const variant = getSelectedProductVariant();
  if (!variant) {
    return Promise.resolve(false);
  }
  hideRechargeWidget();
  updateVariantInUrl(variant.id);

  const requestUrl = getProductSectionRequestUrl(variant.id);
  if (!requestUrl) {
    return Promise.resolve(false);
  }

  return fetch(requestUrl)
    .then((response) => response.text())
    .then((markup) => {
      const replaced = replaceRechargeWidgetMarkup(markup);
      if (replaced) {
        observeRechargeSubscriptionWidget();

        setTimeout(() => {
          updateMainProductButtonPrice();
          showRechargeWidget();
          selectDefaultPlan();
        }, 150);
      } else {
        showRechargeWidget();
      }
      return replaced;
    })
    .catch(() => {
      showRechargeWidget();
      return false;
    });
    
    
}

function selectDefaultPlan() {
  const selectTag = document
    .querySelector('[data-product-template] recharge-subscription-widget')
    ?.shadowRoot?.querySelector('rc-selling-plans')
    ?.shadowRoot?.querySelector('.rc-plans-dropdown__select');

  if (!selectTag) return;

  const targetOption = Array.from(selectTag.options).find(option =>
    option.textContent.toLowerCase().includes('3 weeks')
  );

  if (!targetOption) return;

  selectTag.value = targetOption.value;
  fireEvent(selectTag, 'change');
}

function hideRechargeWidget() {
  const widget = document.querySelector('[data-product-template] recharge-subscription-widget');
  if (widget) {
    widget.setAttribute('hidden', '');
  }
}

function showRechargeWidget() {
  const widget = document.querySelector('[data-product-template] recharge-subscription-widget');
  if (widget) {
    widget.removeAttribute('hidden');
  }
}

function syncRechargeWidgetOnLoad() {
  const productTemplate = document.querySelector('[data-product-template]');
  if (!productTemplate) {
    return;
  }

  fetchRechargeWidgetForSelectedVariant();
}

function getSelectedProductSellingPlanAllocation(variant) {
  if (!variant || !variant.selling_plan_allocations || variant.selling_plan_allocations.length === 0) {
    return null;
  }

  const rechargeWidget = document.querySelector('[data-product-template] recharge-subscription-widget');
  const rechargeWidgetRoot = rechargeWidget && rechargeWidget.shadowRoot ? rechargeWidget.shadowRoot : null;
  if (rechargeWidgetRoot) {
    const selectedPurchaseOption = rechargeWidgetRoot.querySelector('input[name="purchaseOption"]:checked');
    if (selectedPurchaseOption && selectedPurchaseOption.value === 'onetime') {
      return null;
    }

    const widgetPlanId = rechargeWidgetRoot.querySelector('select[name="rc_plan"]')?.value;
    if (widgetPlanId) {
      return variant.selling_plan_allocations.find((allocation) => String(allocation.selling_plan_id) === String(widgetPlanId)) || variant.selling_plan_allocations[0];
    }

    if (selectedPurchaseOption && selectedPurchaseOption.value === 'subscription') {
      return variant.selling_plan_allocations[0];
    }
  }

  const productForm = document.querySelector('[data-product-template] form[action*="/cart/add"]');
  const sellingPlanInput = productForm ? productForm.querySelector('input[name="selling_plan"]') : null;
  const selectedPlanIdFromForm = sellingPlanInput ? sellingPlanInput.value : '';
  if (selectedPlanIdFromForm) {
    return variant.selling_plan_allocations.find((allocation) => String(allocation.selling_plan_id) === String(selectedPlanIdFromForm)) || variant.selling_plan_allocations[0];
  }

  const purchaseOption = document.querySelector('.product__info-wrapper .rc_widget__option__input:checked');
  if (!purchaseOption || purchaseOption.value === 'onetime') {
    return null;
  }

  const selectedPlanId = document.querySelector('.rc-selling-plans-dropdown__select')?.value;
  if (!selectedPlanId) {
    return variant.selling_plan_allocations[0];
  }

  return variant.selling_plan_allocations.find((allocation) => String(allocation.selling_plan_id) === String(selectedPlanId)) || variant.selling_plan_allocations[0];
}

function getActiveProductVariantPrice(variant) {
  const activeAllocation = getSelectedProductSellingPlanAllocation(variant);

  return {
    activeAllocation,
    activePrice: activeAllocation ? activeAllocation.price : variant.price,
    activeComparePrice: activeAllocation ? activeAllocation.compare_at_price : variant.compare_at_price
  };
}

function updateAllProductVariantOptionPrices() {
  const productTemplate = document.querySelector('[data-product-template]');
  if (!productTemplate || productTemplate.querySelector('[data-product-json]') == null) {
    return;
  }

  const productJson = JSON.parse(productTemplate.querySelector('[data-product-json]').textContent);
  const variantMap = new Map(productJson.variants.map((variant) => [String(variant.id), variant]));

  productTemplate.querySelectorAll('[data-variant-option-per-can]').forEach((target) => {
    const variant = variantMap.get(String(target.dataset.variantId));
    if (!variant) {
      return;
    }

    const { activePrice } = getActiveProductVariantPrice(variant);
    const packCount = getProductVariantPackCount(variant);
    target.textContent = packCount > 0 ? `${formatProductMoney(activePrice / packCount)}/can` : '';
  });
}

function updateMainProductButtonPrice() {
  const priceTarget = document.querySelector('[data-product-button-price]');
  const compareTarget = document.querySelector('[data-product-button-compare-price]');
  const perCanTarget = document.querySelector('[data-product-per-can]');
  if (!priceTarget) {
    return;
  }

  const variant = getSelectedProductVariant();
  if (!variant) {
    return;
  }

  const { activePrice, activeComparePrice } = getActiveProductVariantPrice(variant);

  priceTarget.textContent = formatProductMoney(activePrice);

  if (compareTarget) {
    if (activeComparePrice && activeComparePrice !== activePrice) {
      compareTarget.textContent = formatProductMoney(activeComparePrice);
      compareTarget.classList.remove('hidden');
    } else {
      compareTarget.textContent = '';
      compareTarget.classList.add('hidden');
    }
  }

  if (perCanTarget) {
    const packCount = getProductVariantPackCount(variant);
    if (packCount > 0) {
      perCanTarget.textContent = `${formatProductMoney(activePrice / packCount)}/can`;
    } else {
      perCanTarget.textContent = '';
    }
  }

  updateAllProductVariantOptionPrices();
  updateSubscriptionBenefitAmount(variant);
}

function updateSubscriptionBenefitAmount(variant) {
  const targetVariant = variant || getSelectedProductVariant();
  const rechargeWidget = document.querySelector('[data-product-template] recharge-subscription-widget');
  const widgetRoot = rechargeWidget && rechargeWidget.shadowRoot ? rechargeWidget.shadowRoot : null;
  const benefitsRoot = widgetRoot?.querySelector('rc-benefits')?.shadowRoot;
  const benefitItems = benefitsRoot ? Array.from(benefitsRoot.querySelectorAll('li')) : [];
  const savingsBenefitItem = benefitItems.find((item) => item.textContent && item.textContent.toLowerCase().includes('save up to'));

  const fallbackAmountTarget = document.querySelector('[data-subscription-benefit-amount]');

  if (!targetVariant) {
    if (fallbackAmountTarget) {
      fallbackAmountTarget.textContent = 'fees';
    }
    return;
  }

  const activeAllocation = getSelectedProductSellingPlanAllocation(targetVariant);
  const benefitAmount = activeAllocation ? activeAllocation.price : targetVariant.selling_plan_allocations?.[0]?.price;
  const benefitAmountText = benefitAmount ? formatProductMoney(benefitAmount) : '';

  if (savingsBenefitItem) {
    savingsBenefitItem.innerHTML = savingsBenefitItem.innerHTML.replace(/£[\d,.]+/, benefitAmountText);
  }

  if (fallbackAmountTarget) {
    fallbackAmountTarget.textContent = benefitAmountText;
  }
}

function observeRechargeSellingPlanInput() {
  const productForm = document.querySelector('[data-product-template] form[action*="/cart/add"]');
  if (!productForm) {
    return;
  }

  let lastSellingPlanValue = '';
  const syncButtonPrice = function() {
    const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
    const nextValue = sellingPlanInput ? sellingPlanInput.value : '';
    if (nextValue !== lastSellingPlanValue) {
      lastSellingPlanValue = nextValue;
      updateMainProductButtonPrice();
    }
  };

  syncButtonPrice();

  const observer = new MutationObserver(function() {
    syncButtonPrice();
  });

  observer.observe(productForm, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['value']
  });
}

function observeProductVariantChanges() {
  const productTemplate = document.querySelector('[data-product-template]');
  if (!productTemplate) {
    return;
  }

  const variantInputs = productTemplate.querySelectorAll('fieldset input, select[name="id"]');
  if (!variantInputs.length) {
    return;
  }

  const syncPricing = function() {
    setTimeout(function() {
      updateMainProductButtonPrice();
    }, 50);
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', syncPricing);
    input.addEventListener('input', syncPricing);
    input.addEventListener('click', syncPricing);
  });
}

function observeRechargeSubscriptionWidget() {
  const productTemplate = document.querySelector('[data-product-template]');
  if (!productTemplate) {
    return;
  }

  const bindWidgetEvents = function(widget) {
    if (!widget || !widget.shadowRoot || widget.dataset.pdpPriceBound === 'true') {
      return Boolean(widget && widget.shadowRoot);
    }

    const widgetRoot = widget.shadowRoot;
    const purchaseOptionInputs = widgetRoot.querySelectorAll('input[name="purchaseOption"]');
    const planSelect = widgetRoot.querySelector('select[name="rc_plan"]');
    if (!purchaseOptionInputs.length) {
      return false;
    }

    const syncPricing = function() {
      setTimeout(function() {
        updateMainProductButtonPrice();
      }, 50);
    };

    purchaseOptionInputs.forEach((input) => {
      input.addEventListener('change', syncPricing);
      input.addEventListener('click', syncPricing);
    });

    if (planSelect) {
      planSelect.addEventListener('change', syncPricing);
      planSelect.addEventListener('input', syncPricing);
    }

    widget.dataset.pdpPriceBound = 'true';
    syncPricing();
    return true;
  };

  const tryBind = function() {
    return bindWidgetEvents(productTemplate.querySelector('recharge-subscription-widget'));
  };

  if (tryBind()) {
    return;
  }

  const widgetObserver = new MutationObserver(function() {
    if (tryBind()) {
      widgetObserver.disconnect();
    }
  });

  widgetObserver.observe(productTemplate, {
    childList: true,
    subtree: true
  });
}

observeRechargeSellingPlanInput();
observeProductVariantChanges();
observeRechargeSubscriptionWidget();
updateMainProductButtonPrice();
hideRechargeWidget();
syncRechargeWidgetOnLoad();

waitForElm('.rc-widget').then((elm) => {
  //======= For fre dropdown position
         if(elm.querySelector('.rc-selling-plans-dropdown') != null) {
              if(elm.querySelector('.subscription-radio') != null) {
               elm.querySelector('.subscription-radio').append(elm.querySelector('.rc-selling-plans-dropdown'));  
            }
         }


  //===============Position change of info
  if(elm.querySelector('.subscription-radio') != null) {
    if(document.querySelector('[data-subs-content]') != null) {
      elm.querySelector('.subscription-radio').append(document.querySelector('[data-subs-content]'));
    }
  }
  if(elm.querySelector('.onetime-radio') != null) {
    if(document.querySelector('[data-onetime-content]') != null) {
      elm.querySelector('.onetime-radio').append(document.querySelector('[data-onetime-content]'));
    }
  }
  
  
  if(document.querySelector('.rc-selling-plans-dropdown__select')){

    const selectTag = document.querySelector('.rc-selling-plans-dropdown__select');
   // selectTag.value = '1359708221';
    //fireEvent(selectTag, 'change')


    selectTag.querySelectorAll('option').forEach((option, index) => {
          let optionValue = option.innerText.toLowerCase();
          if(optionValue.includes('3 weeks')) {
             console.log('optionValue11', optionValue);
             selectTag.selectedIndex = index;
            fireEvent(selectTag, 'change');
          }
    });

    selectTag.addEventListener('change', function() {
      setTimeout(function () {
        updateMainProductButtonPrice();
      }, 50);
    });
                       
    
  }
  
  let subSaving = document.querySelector('.rc-radio.subscription-radio .discount-label');
 
  
  subSaving.outerHTML = '<span class="discount-label-prepend">SUBSCRIBE</span> ' + subSaving.innerHTML + '  OFF';
  
  // let arrow = document.querySelector('.rc-selling-plans-dropdown__select');      
  // arrow.outerHTML += '<svg xmlns="http://www.w3.org/2000/svg" class="rc-arrow" width="12.134" height="12.134" viewBox="0 0 12.134 12.134"><path id="Path_10_Copy" data-name="Path 10 Copy" d="M.143,0,0,8.05H8.193" transform="translate(0.33 5.799) rotate(-45)" fill="none" stroke="#00577d" stroke-miterlimit="10" stroke-width="0.9"/></svg>';


        let currentVariantNew = '';
        if(document.querySelector('[data-product-template]').querySelector('[data-product-json]') != null) {
          let productJson =  JSON.parse(document.querySelector('[data-product-template]').querySelector('[data-product-json]').textContent);
          let fieldsets = Array.from(document.querySelector('[data-product-template]').querySelectorAll('fieldset'));
          let selectedValue = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          });
          productJson.variants.forEach((variant) => {
                if(JSON.stringify(variant.options) == JSON.stringify(selectedValue)) {
                   unitPrice = variant.price;
                  currentVariantNew = variant;
                } 
           });


            if(productJson.options.length > 0) {
             let packSizeIndex = -1;
             productJson.options.forEach((option, index) => {
                let optionName = option.toLowerCase();
                if(optionName.includes("pack size")) {
                    packSizeIndex = index;
                }
             });
              let productTags = productJson.tags.toString().toLowerCase();
              if(productTags.includes("type_") && packSizeIndex >= 0) {

                let tagName = '';
                productJson.tags.forEach((tag) => {
                   let temp = tag.toLowerCase();
                    if(temp.includes('type_')) {
                       tagName = temp.replace('type_', '');
                    }
                });
             
                let packNumber = Number(currentVariantNew.options[packSizeIndex].toLowerCase().replace('pack', ''));
                let unitPrice = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(currentVariantNew.price/packNumber / 100));
                let priceHTML = `<span>${unitPrice} per ${tagName}</span> ${(new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(currentVariantNew.price/100))}`;
                if(document.querySelector('[data-product-template]').querySelector('.subscription-radio') != null) {
                    let unitPriceSubs = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(currentVariantNew.selling_plan_allocations[0].price/packNumber / 100));
                    let priceSubsHTML = `<span>${unitPriceSubs} per ${tagName}</span> ${(new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(currentVariantNew.selling_plan_allocations[0].price/100))}`;
                    if(document.querySelector('[data-product-template]').querySelector('.subscription-radio .price-label') != null) {
                      document.querySelector('[data-product-template]').querySelector('.subscription-radio .price-label').innerHTML = priceSubsHTML;
                    }
                     if(document.querySelector('[data-product-template]').querySelector('.onetime-radio .price-label') != null) {
                      document.querySelector('[data-product-template]').querySelector('.onetime-radio .price-label').innerHTML = priceHTML;
                    }
                }
              }
           }
          
        }
 
  
  var currentVariant = document.querySelector('.current-variant');
  
  var price = document.querySelector('.rc-radio--active .price-label');
  // var price = document.querySelector('.rc-radio--active .rc-radio__price');

  // console.log(price);

  var html = price.innerHTML;

  var num = +html.replace(/[^0-9.]/g,"");

  //var priceOfItem = currentVariant.innerHTML.split("/")[1];
  
  var nameOfItem = currentVariant.innerHTML.split("/")[0];
  var priceOfItem = '';
  if(currentVariant.innerHTML.split("/")[1] != undefined) {
    priceOfItem = Number(currentVariant.innerHTML.split("/")[1].toLowerCase().replace('pack', '').replace(/\s+/g,''));
  }
  
  var nameOfItem = nameOfItem.slice(0, -2); 

   if(currentVariantNew.options.length == 1 ) {
      // priceOfItem = currentVariant.innerHTML;
      priceOfItem = Number(currentVariant.innerHTML.toLowerCase().replace('pack', '').replace(/\s+/g,''));
    }
  //new price
 
  num = currentVariantNew.selling_plan_allocations[0].price;
 
  var priceOfItem = (num / priceOfItem);

  var priceText = document.querySelector('.breakdown-price');
  var itemText = document.querySelector('.breakdown-item');

  priceText.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(priceOfItem/100));

  updateMainProductButtonPrice();

    if( currentVariantNew.options.length >= 2 ) {
      itemText.textContent = (nameOfItem); 
    }
  

  document.querySelector(".rc-radio.subscription-radio input").addEventListener("click",function(e) {

    // setTimeout(() => {
    //   const selectTag = document.querySelector('.rc-selling-plans-dropdown__select');
    //   selectTag.value = '1359708221';
    //    console.log({selectTag})
    //   fireEvent(selectTag, 'change')
    // }, 100)

    var priceSub = document.querySelector('.sub-price');
    var priceNormal = document.querySelector('.normal-price');

    priceSub.classList.remove('hidden');
    priceNormal.classList.add('hidden');
    
    let sub = document.querySelector('.sub-container');
    let otp = document.querySelector('.otp-container');
   // otp.classList.add('hidden');
    sub.classList.remove('hidden');
    
    setTimeout(function () {
      updateMainProductButtonPrice();



       //================New script
               
        let unitPrice = '';
       let currentVariantNew = '';
        if(document.querySelector('[data-product-template]').querySelector('[data-product-json]') != null) {
          let productJson =  JSON.parse(document.querySelector('[data-product-template]').querySelector('[data-product-json]').textContent);
          let fieldsets = Array.from(document.querySelector('[data-product-template]').querySelectorAll('fieldset'));
          let selectedValue = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          });
            productJson.variants.forEach((variant) => {
                if(JSON.stringify(variant.options) == JSON.stringify(selectedValue)) {
                   unitPrice = variant.selling_plan_allocations[0].price;
                   currentVariantNew = variant;
                } 
           });
         }

            


      
      // let arrow = document.querySelector('.rc-selling-plans-dropdown__select');      
      // arrow.outerHTML += '<svg xmlns="http://www.w3.org/2000/svg" class="rc-arrow" width="12.134" height="12.134" viewBox="0 0 12.134 12.134"><path id="Path_10_Copy" data-name="Path 10 Copy" d="M.143,0,0,8.05H8.193" transform="translate(0.33 5.799) rotate(-45)" fill="none" stroke="#00577d" stroke-miterlimit="10" stroke-width="0.9"/></svg>';
      
      // console.log('sub running');
      
      var currentVariant = document.querySelector('.current-variant');
      
      var price = document.querySelector('.rc-radio--active .price-label');
      // var price = document.querySelector('.rc-radio--active .rc-radio__price');
    
      var html = price.innerHTML;
  
      var num = +html.replace(/[^0-9.]/g,"");
  
      //var priceOfItem = currentVariant.innerHTML.split("/")[1];
      var priceOfItem = '';
      if(currentVariant.innerHTML.split("/")[1] != undefined) {
        priceOfItem = Number(currentVariant.innerHTML.split("/")[1].toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }
      var nameOfItem = currentVariant.innerHTML.split("/")[0];
  
      var nameOfItem = nameOfItem.slice(0, -2); 

      var newPriceOfItem = priceOfItem;
      
  

      if(currentVariantNew.options.length == 1 ) {
        // priceOfItem = currentVariant.innerHTML;
         priceOfItem = Number(currentVariant.innerHTML.toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }

       console.log('priceOfItem', priceOfItem, unitPrice);
     // var priceOfItem = (num / priceOfItem);
      var priceOfItem = (unitPrice / Number(priceOfItem));
  
      var priceText = document.querySelector('.breakdown-price');
      var itemText = document.querySelector('.breakdown-item');
  
      priceText.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(priceOfItem/100));

       if( currentVariantNew.options.length >= 2 ) {
      itemText.textContent = (nameOfItem);
       }

      var cartTotal = document.querySelector('.cart-message');
      var cartTotal = cartTotal.getAttribute('data-total');
      var cartTotal = (cartTotal / 100);
  
      var spendThreshold = document.querySelector('.spend-promo');
      var spendThreshold = spendThreshold.getAttribute('data-price');
      var spendThreshold = (spendThreshold / 100);
  
      var currentPrice = num;
  
      var newSpend = (spendThreshold - cartTotal - currentPrice);
  
      var spendToDisplay = (cartTotal + currentPrice);
      
      var spendWrapper = document.querySelector('.product__info-wrapper .spending-wrapper');
      var toReach = document.querySelector('.product__info-wrapper .to-reach');
      var toSpend = document.querySelector('.product__info-wrapper .to-spend');
      var reached = document.querySelector('.product__info-wrapper .reached');
  
      toSpend.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(newSpend));
  
      if(spendThreshold > spendToDisplay) {
        // console.log('spendThreshold more');
        toReach.classList.remove('hidden');
        reached.classList.add('hidden');
      } else {
        // console.log('spendThreshold less');
        toReach.classList.add('hidden');
        reached.classList.remove('hidden');
      }


               
      
      
    }, 1000);
  });
  
  document.querySelector(".rc-radio.onetime-radio input").addEventListener("click",function(e) {
    setTimeout(function () {
      updateMainProductButtonPrice();
    }, 50);


    //================New script
               
        let unitPrice = '';
        let currentVariantNew = '';
        if(document.querySelector('[data-product-template]').querySelector('[data-product-json]') != null) {
          let productJson =  JSON.parse(document.querySelector('[data-product-template]').querySelector('[data-product-json]').textContent);
          let fieldsets = Array.from(document.querySelector('[data-product-template]').querySelectorAll('fieldset'));
          let selectedValue = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          });
            productJson.variants.forEach((variant) => {
                if(JSON.stringify(variant.options) == JSON.stringify(selectedValue)) {
                   unitPrice = variant.price;
                  currentVariantNew = variant;
                } 
           });
         }

    
    var priceSub = document.querySelector('.sub-price');
    var priceNormal = document.querySelector('.normal-price');

    priceSub.classList.add('hidden');
    priceNormal.classList.remove('hidden');

    let sub = document.querySelector('.sub-container');
    let otp = document.querySelector('.otp-container');
    otp.classList.remove('hidden');
    //sub.classList.add('hidden');
    
    setTimeout(function () {
      
      // console.log('non sub running');      
      
      var currentVariant = document.querySelector('.current-variant');
      
      var price = document.querySelector('.rc-radio--active .price-label');
      // var price = document.querySelector('.rc-radio--active .rc-radio__label');
    
      var html = price.innerHTML;
  
      var num = +html.replace(/[^0-9.]/g,"");
  
     // var priceOfItem = currentVariant.innerHTML.split("/")[1];
      var priceOfItem = '';
      if(currentVariant.innerHTML.split("/")[1] != undefined) {
        priceOfItem = Number(currentVariant.innerHTML.split("/")[1].toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }
      var nameOfItem = currentVariant.innerHTML.split("/")[0];
  
      var nameOfItem = nameOfItem.slice(0, -2); 


      if(currentVariantNew.options.length == 1 ) {
        // priceOfItem = currentVariant.innerHTML;
        priceOfItem = Number(currentVariant.innerHTML.toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }
      
 
      var priceOfItem = (unitPrice / Number(priceOfItem));

      var newPriceOfItem = priceOfItem;
        
      var priceText = document.querySelector('.breakdown-price');
      var itemText = document.querySelector('.breakdown-item');

       
  
      priceText.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(priceOfItem/100));

       if( currentVariantNew.options.length >= 2 ) {
            itemText.textContent = (nameOfItem);  
       }

      var cartTotal = document.querySelector('.cart-message');
      var cartTotal = cartTotal.getAttribute('data-total');
      var cartTotal = (cartTotal / 100);
  
      var spendThreshold = document.querySelector('.spend-promo');
      var spendThreshold = spendThreshold.getAttribute('data-price');
      var spendThreshold = (spendThreshold / 100);
  
      var currentPrice = num;

      // console.log(currentPrice);
  
      var newSpend = (spendThreshold - cartTotal - currentPrice);
  
      var spendToDisplay = (cartTotal + currentPrice);
      
      var spendWrapper = document.querySelector('.product__info-wrapper .spending-wrapper');
      var toReach = document.querySelector('.product__info-wrapper .to-reach');
      var toSpend = document.querySelector('.product__info-wrapper .to-spend');
      var reached = document.querySelector('.product__info-wrapper .reached');
  
      toSpend.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(newSpend));
  
      if(spendThreshold > spendToDisplay) {
        // console.log('spendThreshold more');
        toReach.classList.remove('hidden');
        reached.classList.add('hidden');
      } else {
        // console.log('spendThreshold less');
        toReach.classList.add('hidden');
        reached.classList.remove('hidden');
      }

      
    }, 1000);
  });

});
